<template>
  <div>
    <div class="page-title">編輯練習</div>
    <div class="page-box">
      <practiceFrom ref="ruleForm" :formLabelAlign="formLabelAlign"></practiceFrom>
      <div>請注意：標有 (<span class="star-mark">*</span>) 的為必填項。</div>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="backIndexpage">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getPractisesDetail,putPractise } from "@/api/practises";
import practiceFrom from "./components/practiceFrom.vue";
export default {
  components: { practiceFrom },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      formLabelAlign: {
        id: 0,
        number: null,
        lang: 0,
        type: 0,
        guideVideoUrl: '',
        guideImageUrl: '',
        randomNumber: 0,
        passScore: 0,
        questions: [],
      },
    };
  },
  created(){
    this.getPractisesDetail()
  },
  methods: {
    onSubmit() {
       this.$refs.ruleForm.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.putPractise()
          } else {
            return false;
          }
        });
    },
   
    putPractise(){
      if(this.formLabelAlign.type==1){
         this.formLabelAlign.guideVideoUrl = ''
      }else {
         this.formLabelAlign.guideImageUrl =''
      }
      putPractise(this.id,this.formLabelAlign).then(()=>{
        this.$message({
          message: "提交成功",
          type: "success",
        });
        this.$router.push({ name: 'practice' })
      })
    },
    backIndexpage() {
      this.$router.push('/practice')
    },
    getPractisesDetail(){
      getPractisesDetail(this.id).then((v)=>{
         this.formLabelAlign = v.data
         this.formLabelAlign.type = this.formLabelAlign.guideImageUrl?1:0
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;
}
</style>